import React from 'react'
import { services } from 'api/api'
import { The } from 'helpers/generalHelpers'
import AsyncDropdown from '../SelectDropdown/AsyncDropdown'

class SearchableField extends React.Component {
  getFieldOptions = async (fieldSlug, params = {}) => {
    const response = await The(services.field.getChoices(fieldSlug, params))
    return response
  }

  render() {
    return <AsyncDropdown getOptions={this.getFieldOptions} {...this.props} />
  }
}
export default SearchableField
